import React, { useEffect, useState } from "react";
import axiosClient from "../../api/axiosClient";
import { Table, Button, Form, Alert, Badge, InputGroup, Pagination } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const UserList = () => {
  const [users, setUsers] = useState([]);
  const [searchUsername, setSearchUsername] = useState("");
  const [filterStatus, setFilterStatus] = useState("all");
  const [currentPage, setCurrentPage] = useState(1);
  const usersPerPage = 5;

  const navigate = useNavigate();

  // Fetch VIP users
  const fetchUsers = async () => {
    try {
      const res = await axiosClient.get("/users");
      setUsers(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  // Handle view user
  const handleViewUser = (user) => {
    navigate(`/admin/users/${user.id}`);
  };

  // Filter users
  const filteredUsers = users.filter((u) => {
    const matchesUsername = u.username.toLowerCase().includes(searchUsername.toLowerCase());
    const matchesStatus =
      filterStatus === "all" ? true : filterStatus === "active" ? u.status : !u.status;
    return matchesUsername && matchesStatus;
  });

  // Pagination logic
  const indexOfLastUser = currentPage * usersPerPage;
  const indexOfFirstUser = indexOfLastUser - usersPerPage;
  const paginatedUsers = filteredUsers.slice(indexOfFirstUser, indexOfLastUser);
  const totalPages = Math.ceil(filteredUsers.length / usersPerPage);

  const handlePageChange = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <div>
      {/* <h4 className="mb-3">VIP Users</h4> */}

      {/* Search & Filter */}
      <InputGroup className="mb-3">
        <Form.Control
          placeholder="Search by username..."
          value={searchUsername}
          onChange={(e) => setSearchUsername(e.target.value)}
        />
        <Form.Select value={filterStatus} onChange={(e) => setFilterStatus(e.target.value)}>
          <option value="all">All Status</option>
          <option value="active">Active</option>
          <option value="disabled">Disabled</option>
        </Form.Select>
      </InputGroup>

      <Table striped bordered hover responsive>
        <thead>
          <tr>
            <th>ID</th>
            <th>Photo</th>
            <th>Username</th>
            <th>Status</th>
            <th className="text-center">Actions</th>
          </tr>
        </thead>
        <tbody>
          {paginatedUsers.length === 0 ? (
            <tr>
              <td colSpan="5" className="text-center">
                No VIP users found.
              </td>
            </tr>
          ) : (
            paginatedUsers.map((u) => (
              <tr key={u.id}>
                <td>{u.id}</td>
                <td className="text-center">
                  {u.photo ? (
                    <img
                      src={`http://localhost:5000${u.photo}`}
                      alt="profile"
                      className="rounded-circle border"
                      width="50"
                      height="50"
                    />
                  ) : (
                    <span className="text-muted">No Photo</span>
                  )}
                </td>
                <td>{u.username}</td>
                <td className="text-center">
                  <Badge bg={u.status ? "success" : "secondary"}>
                    {u.status ? "Active" : "Disabled"}
                  </Badge>
                </td>
                <td className="text-center">
                  <Button variant="primary" size="sm" onClick={() => handleViewUser(u)}>
                    View
                  </Button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </Table>

      {/* Pagination */}
      {totalPages > 1 && (
        <Pagination className="justify-content-center">
          {[...Array(totalPages)].map((_, i) => (
            <Pagination.Item
              key={i + 1}
              active={i + 1 === currentPage}
              onClick={() => handlePageChange(i + 1)}
            >
              {i + 1}
            </Pagination.Item>
          ))}
        </Pagination>
      )}
    </div>
  );
};

export default UserList;
